export const GA_PRODUCT_PAGE = 'product';
export const GA_LISTING_PAGE = 'listing';
export const GA_SEARCH_PAGE = 'search';
export const GA_CHECKOUT_PAGE = 'checkout';
export const GA_AUTHENTICATION_PAGE = 'authentication';
export const GA_PROFILE_PAGE = 'profile';
export const GA_CUSTOMER_PAGE = 'customer';
